import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderStatisticsService {
  constructor(protected http: HttpClient) {}

  getOrderStatistics(date): Observable<any> {
    return this.http.get<any>('json/order-statistics-nostream?minDate=' + date);
  }
}
